import { useApiMutation } from '../useApiMutation';
import { operationsClient, apiPost } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import type { SlotStatus } from '@/types/scheduler';

interface ReserveSlotInput {
  slotId: string;
  technicianId: string;
  serviceTypeId: string;
  startAt?: string;
  endAt?: string;
  score?: number;
}

/**
 * The reserve endpoint returns the PERSISTED slot (its own `id`), which may
 * differ from the ephemeral availability `slotId` the caller submitted — the
 * engine reuses an existing slot for the same technician+time. Downstream calls
 * (reschedule/booking) must use this `id`, not the ephemeral one.
 */
export interface ReservedSlot {
  id: string;
  startAt: string;
  endAt: string;
  timezone: string;
  technicianId: string;
  serviceTypeId: string;
  status: SlotStatus;
  reservedAt?: string | null;
  expiresAt?: string | null;
}

export function useReserveSlot() {
  return useApiMutation<ReservedSlot, ReserveSlotInput>({
    mutationFn: ({ slotId, ...body }) =>
      apiPost<ReservedSlot>(operationsClient, schedulerEndpoints.reserveSlot(slotId), body),
  });
}
